module.exports = __webpack_public_path__ + "b1027d423577ecc1b692ef6996b5f7c5.pdf";